<template>
    <div>
        <Backer />
        <div class="fm-container">
            <div>
                <b-card-group column>
                    <b-card
                        border-variant="dark"
                        header="Purchase Orders"
                        header-bg-variant="dark"
                        header-text-variant="white"
                        align="center"
                        style="max-width: 300px;"
                    >
                        <b-card-text>
                            <b-button variant="dark" v-on:click="$router.push('/purchase_orders/new/')">
                                New Purchase Order
                            </b-button>
                        </b-card-text>

                        <b-card-text>
                            <b-button variant="dark" v-on:click="$router.push('/purchase_orders/')">
                                List Purchase Orders
                            </b-button>
                        </b-card-text>
                    </b-card>
                </b-card-group>
            </div>
        </div>
    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    export default {
        name: "ManagePurchaseOrders",
        components: {Backer},
        data: function(){
            return {

            }
        },
        methods: {},
        created: function(){

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ManagePurchaseOrders.vue